import { RedisConfigModel } from './models/redis-config.model';
import { Injectable } from '@nestjs/common';
import BullQueue from "bull";
import Redis from "ioredis";
import { jobConfigs } from '../../../config';
import { BULLJSQUEUENAMES } from '@gtpl/shared-models/common-models';

@Injectable()
export class RedisHelperService {
    constructor(
    ) {

    }

    /**
     * adds the the given payload to the given redis queue
     * @param queueName 
     * @param data 
     * @param jobConfig 
     * @param redisConfig 
     * @returns 
     */
    async addJobToQueue(queueName: BULLJSQUEUENAMES, data: any, redisConfig: RedisConfigModel, jobConfig?: BullQueue.JobOptions): Promise<boolean> {
        let redisConnection: Redis.Redis;
        try {
            const redisOptions = {
                retry_strategy: null,
                maxRetriesPerRequest: null,
                reconnectOnError: (err: Error) => { return false }
            }
            // establish the redis connection
            redisConnection = redisConfig ? new Redis(redisConfig.port, redisConfig.host, { password: redisConfig.password, ...redisOptions }) : new Redis(jobConfigs.redis.port, jobConfigs.redis.host, { password: jobConfigs.redis.password, ...redisOptions })
            // Setting up the queue
            const queueInstance = new BullQueue(queueName, {
                redis: {
                    host: redisConnection.options.host,
                    port: redisConnection.options.port,
                    password: redisConnection.options.password
                },
                defaultJobOptions: {
                    ...jobConfigs.bullJobOptions,
                }, settings: {
                    ...jobConfigs.bullAdvancedSettings
                }
            });
            await queueInstance.add(queueName, data, jobConfig);
            // close the queue
            await queueInstance.close();
            // release the connection 
            redisConnection.disconnect();
            return true;
        } catch (error) {
            // release the connection 
            redisConnection.disconnect();
            throw error;
        }
    }
    /**
     * 
     * @param queName string
     * @returns 
     */
    async removeAllRepeatable(queueName: string, redisConfig: RedisConfigModel, jobConfig?: BullQueue.JobOptions): Promise<boolean> {
        let redisConnection: Redis.Redis;
        try {
            const redisOptions = {
                retry_strategy: null,
                maxRetriesPerRequest: null,
                reconnectOnError: (err: Error) => { return false }
            }
            // establish the redis connection
            redisConnection = redisConfig ? new Redis(redisConfig.port, redisConfig.host, { password: redisConfig.password, ...redisOptions }) : new Redis(jobConfigs.redis.port, jobConfigs.redis.host, { password: jobConfigs.redis.password, ...redisOptions });
            const queueInstance = new BullQueue(queueName, {
                redis: {
                    host: redisConnection.options.host,
                    port: redisConnection.options.port,
                    password: redisConnection.options.password
                },
                defaultJobOptions: {
                    ...jobConfigs.bullJobOptions,
                }, settings: {
                    ...jobConfigs.bullAdvancedSettings
                }
            });

            const jobs = await queueInstance.getRepeatableJobs();
            for (let i = 0; i < jobs.length; i++) {
                const job = jobs[i];
                await queueInstance.removeRepeatable(queueName, { cron: job.cron, jobId: job.id });
            }
            // close the queue
            await queueInstance.close();
            // release the connection 
            redisConnection.disconnect();
            return true;
        } catch (error) {
            // release the connection 
            redisConnection.disconnect();
            throw error;
        }

    };

}